import { axiosIns } from './index';
import { ApiResponse } from '../typings/ApiResponse';

interface LoginResponse {
  data: string;
  userId: string;
}

export interface VerifyOtpUser {
  id?: string;
  uuid?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  [key: string]: any;
}

export interface VerifyOtpData {
  user: VerifyOtpUser;
  token: string;
}

const createAccount = async (
  token: string,
  password: string
): Promise<LoginResponse> => {
  const response = await axiosIns.post('/carehome/auth/create-account', {
    token,
    password,
  });
  return response.data;
};

const forgotPassword = async (email: string): Promise<ApiResponse<null>> => {
  const response = await axiosIns.post('/carehome/forgot-password', {
    email,
  });
  return response.data;
};

const resetPassword = async (
  token: string,
  newPassword: string
): Promise<ApiResponse<null>> => {
  const response = await axiosIns.post('/carehome/reset-password', {
    token,
    newPassword,
  });
  return response.data;
};

const changePassword = async (
  oldPassword: string,
  newPassword: string
): Promise<ApiResponse<null>> => {
  const response = await axiosIns.post('/carehome/auth/change-password', {
    oldPassword,
    newPassword,
  });
  return response.data;
};

const changeEmail = async (
  currentEmail: string,
  newEmail: string
): Promise<ApiResponse<null>> => {
  const response = await axiosIns.post('/carehome/member/update-email', {
    currentEmail,
    newEmail,
  });
  return response.data;
};

const verifyChangingEmail = async (
  token: string
): Promise<ApiResponse<null>> => {
  const response = await axiosIns.post('/carehome/member/verify-new-email', {
    token,
  });
  return response.data;
};

const resendVerificationEmail = async (
  newEmail: string
): Promise<ApiResponse<null>> => {
  const response = await axiosIns.post(
    '/carehome/member/resend-verification-email',
    {
      newEmail,
    }
  );
  return response.data;
};

const verifyOtp = async (
  uuid: string,
  otp: string
): Promise<ApiResponse<VerifyOtpData>> => {
  const response = await axiosIns.post('/carehome/auth/verify-otp', {
    uuid,
    otp,
  });
  return response.data;
};

export {
  createAccount,
  forgotPassword,
  resetPassword,
  changePassword,
  changeEmail,
  verifyChangingEmail,
  resendVerificationEmail,
  verifyOtp,
};
